import { Shield, Users, Award, Sparkles } from 'lucide-react';

const features = [
  { icon: Shield, title: 'Segurança Garantida', description: 'Viagens totalmente asseguradas com suporte 24/7 em qualquer lugar do mundo.', color: 'from-blue-500 to-blue-600' },
  { icon: Sparkles, title: 'Experiências Premium', description: 'Acesso exclusivo a hotéis de luxo, tours privados e experiências únicas.', color: 'from-orange-500 to-red-500' },
  { icon: Users, title: 'Guias Especializados', description: 'Equipe de profissionais experientes que conhecem cada destino profundamente.', color: 'from-teal-500 to-cyan-500' },
  { icon: Award, title: 'Prêmios & Reconhecimento', description: 'Agência premiada com especialistas que possuem mais de 4 anos de experiência.', color: 'from-purple-500 to-pink-500' },
];

export default function Features() {
  return (
    <section className="section-divider bg-gradient-to-br from-slate-50 to-slate-100 relative overflow-hidden">
      <div className="absolute inset-0 bg-white/85"></div>
      <div className="container relative z-10">
        <div className="text-center mb-16 fade-in-up">
          <div className="inline-block px-4 py-2 bg-accent/10 border border-accent/30 rounded-full mb-4">
            <p className="text-accent font-bold text-sm">DIFERENCIAIS</p>
          </div>
          <h2 className="text-primary mb-4">POR QUE ESCOLHER JM TRAVEL?</h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-medium">
            Oferecemos mais do que viagens, oferecemos experiências transformadoras com padrão.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="group p-6 rounded-2xl bg-white border border-border hover:border-accent hover:shadow-2xl transition-all duration-300 fade-in-up" style={{ animationDelay: `${index * 100}ms` }}>
                <div className={`mb-4 inline-block p-4 bg-gradient-to-br ${feature.color} rounded-xl group-hover:scale-110 transition-transform duration-300`}>
                  <Icon size={32} className="text-white" />
                </div>
                <h3 className="text-lg font-bold text-primary mb-2">{feature.title.toUpperCase()}</h3>
                <p className="text-muted-foreground text-sm leading-relaxed">{feature.description}</p>
                <div className="mt-4 h-1 w-0 bg-gradient-to-r from-primary to-accent rounded-full group-hover:w-8 transition-all duration-300"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
